module.exports = __webpack_public_path__ + "static/img/f5772a3f.png";